import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_AMORTIZATIONS}/notifications`

export default (id, payload = {}) =>
  http.put(`${api}/${id}`, payload)
